import axios from "axios";
import useDataDevice from "hooks/useDataDevice";
import { useCallback, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const generateUUID = (): string => {
  return uuidv4();
};

export const useInteractionTracker = () => {
  const LOCAL_STORAGE_KEY = "2aiBNMiSlg";
  const ONE_SECOND = 1000;
  const TTL = 1000;
  const [ip, setIP] = useState<string | null>(() =>
    localStorage.getItem(LOCAL_STORAGE_KEY)
  );
  const { getBrowserName, getOS } = useDataDevice();

  const sendDataToApi = (
    id: string,
    ip: string,
    timestamp: string,
    nameFunc: string
  ) => {
    axios
      .post(
        process.env.REACT_APP_LOG_URL+"/register",
        {
          codApp: "A272",
          nameFunc: nameFunc,
          idTransaction: id,
          timestamp: timestamp,
          ipOrigen: ip,
          browser: getBrowserName(),
          soVersion: getOS(),
          ...(process.env.REACT_APP_ENV
            ? { environment: process.env.REACT_APP_ENV }
            : {}),
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_LOGGING_API_KEY ?? "xxxxxx",
          },
        }
      )
      .then((_response) => {})
      .catch((error) => {
        console.error("Error sending data to Log API:", error);
      });
  };

  const fetchIP = useCallback(async () => {
    if (!ip) {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIP(data.ip);
        localStorage.setItem(LOCAL_STORAGE_KEY, data.ip);
        return data.ip;
      } catch (error) {
        console.error("Error receiving data from IP API:", error);
      }
    }
    return ip;
  }, [ip]);

  const markInteractionStart = async (tag: string, nameFunc: string) => {
    if (!sessionStorage.getItem(tag)) {
      const id = generateUUID();
      const timestamp = new Date().toISOString();
      const item = {
        value: id,
        expiry: new Date().getTime() + TTL * ONE_SECOND,
      };
      sessionStorage.setItem(tag, JSON.stringify(item));

      const userIp = await fetchIP();
      sendDataToApi(id, userIp, timestamp, nameFunc);
    } else {
      sessionStorage.removeItem(tag);
    }
  };

  const markInteractionEnd = async (tag: string, nameFunc: string) => {
    const itemStr = sessionStorage.getItem(tag);
    if (itemStr) {
      sessionStorage.removeItem(tag);
      const timestamp = new Date().toISOString();
      const item = JSON.parse(itemStr);
      if (new Date().getTime() < item.expiry) {
        const id = item.value;
        const userIp = await fetchIP();
        sendDataToApi(id, userIp, timestamp, nameFunc);
      }
    }
  };

  useEffect(() => {
    if (!ip) {
      fetchIP();
    }
  }, [ip, fetchIP]);


  return { markInteractionStart, markInteractionEnd, fetchIP };
};

export default useInteractionTracker;
